import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AppProvider } from "./contexts/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import "./styles/style.scss";
// import { RecoilRoot } from "jotai";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(

		
			<BrowserRouter>
				<AppProvider>
				{/* <React.StrictMode> */}
					<App />
					{/* </React.StrictMode> */}
				</AppProvider>
			</BrowserRouter>
		
	
);
